<template>
  <div id="loginpassword">
  
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">密码登录 </li>
</ul>
</div>
</div>

<div class="col-md-6 col-md-offset-2">
<div class="panel panel-default" style="margin-top:40px">
  <div class="panel-heading">用户登录</div>

    <div class="panel-body">


<form class="form-horizontal" action="" method="post">
  <div class="form-group">
    <label for="inputEmail3" class="col-sm-2 control-label">用户</label>
    <div class="col-sm-8">
      <input type="text" class="form-control" name="username" id="inputEmail3" placeholder="用户"  v-model="username" >
    </div>
  </div>
  <div class="form-group">
    <label for="inputPassword3" class="col-sm-2 control-label">密码</label>
    <div class="col-sm-8">
      <input type="password" class="form-control" id="inputPassword3" name="password" v-model="password" placeholder="Password">
    </div>
  </div>
  
  <div class="form-group">
    <div class="col-sm-offset-2 col-sm-8">
      <button type="button" class="btn btn-default" v-on:click="login()">登录</button>
    </div>
  </div>
</form>

<div class="form-group">

<div class="col-sm-3 control-label" style="padding-left:40px">
<a href="/loginpassword">账号密码登录</a>
</div>
<div class="col-sm-3 control-label" style="padding-left:40px">
<a href="/reg">用户注册</a>
</div>
</div>

</div>


<div class="panel-footer text-right">版权所有giazh.com</div>
</div>
</div>
<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                            <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>
                    </div>
                </div>
            </div>

</div>


</div>



  </div>


</template>

<script>

export default {
  name: 'LoginPassword',
  data(){
  return {
  title:"登录",
  password: '' ,
  username: '' ,
  islogin:false,
  msg:'',

  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
     login: function () {
        var url="https://www.giazh.com/auth/login";

	this.$http.post(url,{username:this.username,password:this.password},{emulateJSON:true}).then(successResponse => {
						if (successResponse.body.status === "success") {
							console.log(successResponse);
							var authorization=successResponse.headers.map.authorization;
							console.log(authorization);
							localStorage.setItem('authorization',authorization);
							localStorage.setItem('username',successResponse.body.username);
							//登录成功跳转页面
							//this.$router.push('/vi');
              this.$router.go(-1); 
							
						}
					}).catch(err => {
						if(err.body.error=='invalid.credentials'){
						alert('账号或密码错误');
						}
					      });


    }
  },
  components:{
  },
  created(){
	       if(localStorage.authorization){
		this.$router.push('/search');
		 }
		 

  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}



.thirdpart-login-icon {
    margin: 0;
    width: 120px;
    height: 26px;
    text-align:right;
}

.icon-weixin {
    background-image: url(https://gw.alicdn.com/tfs/TB1A8GcBAP2gK0jSZPxXXacQpXa-72-72.png);
    background-size: contain;
    background-repeat: no-repeat;
    display: inline-block;
}

</style>


// WEBPACK FOOTER //
// src/components/LoginPassword.vue